import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import NetworkReportLayout from "./NetworkReportLayout";
import NetworkReportOverviewTab from "./pages/NetworkReportOverviewTab";
import NetworkReportOrganizationsTab from "./pages/NetworkReportOrganizationsTab";
import NetworkReportFactorsTab from "./pages/NetworkReportFactorsTab";
import NetworkReportPairingTab from "./pages/NetworkReportPairingTab";
import NetworkReportSchoolsFactorsTab from "./pages/NetworkReportSchoolsFactorsTab";

const NetworkReportRoutes = () => (
  <Routes>
    <Route element={<NetworkReportLayout />}>
      <Route index element={<Navigate to="overview" replace />} />
      <Route path="overview" element={<NetworkReportOverviewTab />} />
      <Route path="organizations" element={<NetworkReportOrganizationsTab />} />
      <Route path="factors" element={<NetworkReportFactorsTab />} />
      <Route path="pairing" element={<NetworkReportPairingTab />} />
      <Route path="schools-factors" element={<NetworkReportSchoolsFactorsTab />} />
    </Route>
  </Routes>
);

export default NetworkReportRoutes;
